import { storeApi } from '@shared/config/axios';

export default {
  getTraining(slug) {
    return storeApi.$get(`/trainings/${slug}`);
  },
  submitCustomFieldAnswers(slug, answers) {
    return storeApi.$put(`/customers/me/trainings/${slug}/fields`, answers);
  },
  dismissCustomFieldAnswers(slug) {
    return storeApi.$put(`/customers/me/trainings/${slug}/fields/dismiss`);
  },
};
